import React, { useEffect, useState } from 'react';

import './BookingPage.scss';

import BookingForm from './../../forms/BookingForm/BookingForm';

const BookingPage = () => {
  const [mun, setMun] = useState([]);
  const [committeeName, setCommitteeName] = useState([]);

  let time;
  let date;
  // let country;
  // let name;

  useEffect(() => {
    fetch('http://localhost:8080/muns/mun')
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('Failed to fetch mun.');
        }
        return res.json();
      })
      .then((resData) => {
        setMun(resData);
        // console.log(resData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (mun.muns) {
    time = mun.muns[0].time;
    date = mun.muns[0].date;
  }

  // console.log(committeeName[0].committeeName);
  // console.log(committeeName[1].committeeName);
  // console.log(committeeName[2].committeeName);

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, []);

  date = new Date(date).toLocaleDateString('en-us', {
    // weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <div className="booking-page-box">
      <div className="container">
        <BookingForm
          time={time}
          date={date}
          // committeeName={committeeName}
        ></BookingForm>
      </div>
    </div>
  );
};

export default BookingPage;
